const NAME_TO_STYLE_KEY = {
  Traditional: 'traditional',
  Fresh: 'fresh',
  'Color Vision': 'colorVision',
  Signal: 'signal',
};

export function translateChartStyleName(style, t) {
  const key = style?.styleKey || NAME_TO_STYLE_KEY[style?.name];
  if (key) {
    const translated = t(`chartStyles.${key}`, { defaultValue: '' });
    if (translated) return translated;
  }
  return style?.name ?? '';
}
